
import { defineComponent, PropType } from "vue";
import { IVatTuDinhMucCoDinh } from "@/core/interfaces/ApiResponses";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import { swalErrNotification } from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";

import WordBreakColumn from "@/components/shared/work-break-column/WordBreakColumn.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import useVatTu from "@/core/hooks/use-vat-tu";
import { useLoading } from "@/core/hooks/use-loading";
import { DinhMucCoDinhService } from "@/core/services/DinhMucCoDinh.service";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "vat-tu-dinh-muc-table",

  emits: ["on-close"],

  components: {
    ButtonCustom,
    WordBreakColumn,
  },

  setup() {
    const { push } = useRouterCustom();

    const { ButtonTypeColors, ButtonsType } = useButtonCustom();

    const { isTextDangerColumn, isValidLabel } = useVatTu();

    const { startLoading, endLoading } = useLoading();

    const { push: pushRouter } = useRouter();

    return {
      ButtonTypeColors,
      ButtonsType,
      endLoading,
      isTextDangerColumn,
      isValidLabel,
      push,
      pushRouter,
      startLoading,
    };
  },

  props: {
    idDinhMuc: {
      type: Number as PropType<number | undefined>,
      default: undefined,
    },
    showDonGia: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      dataItems: [] as IVatTuDinhMucCoDinh[],
      isDialogDisplay: false,
    };
  },
  watch: {
    idDinhMuc(value) {
      if (value) {
        this.isDialogDisplay = true;

        this.fetchData(value);
      }
    },
  },

  methods: {
    formatQuantity,
    formatUnitPrice,
    formatAmount,
    calcLineAmount,
    async fetchData(idDinhMuc: number) {
      try {
        await this.startLoading();

        const {
          data: {
            data: { vat_tu },
          },
        } = await DinhMucCoDinhService.get(idDinhMuc);

        this.dataItems = vat_tu;

        await this.endLoading();
      } catch (e) {
        this.isDialogDisplay = false;

        await this.endLoading();

        await swalErrNotification(
          e,
          "Có lỗi xảy ra khi lấy thông tin định mức cố định"
        );
      }
    },
  },
});
